import { yupResolver } from '@hookform/resolvers/yup';
import { TextField } from '@material-ui/core';
import React, { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AdministrationUserCreateForm } from 'types';
import { sanitizeAlphaNumeric, sanitizeAlphaNumericAndSpecial } from 'utils/formatter';
import { AdministrationUserCreateStep3Schema } from './Step3.yup';
import { useStyles } from './styles';
import { AdministrationUserCreateStepProps } from './types';

export const Step3: React.FC<AdministrationUserCreateStepProps> = ({
  onSubmit,
  formName,
  previousStepData,
  formContext,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });
  const schema = useMemo(() => AdministrationUserCreateStep3Schema(t), [t]);

  const defaultValues = {
    email: '',
    firstName: '',
    lastName: '',
  };

  const { control, handleSubmit, setValue } = useForm<AdministrationUserCreateForm>({
    mode: 'onBlur',
    defaultValues: { ...defaultValues, ...previousStepData },
    resolver: yupResolver(schema),
  });

  const readOnly = Boolean(formContext?.userExists);

  return (
    <form className={classes.form} id={formName} onSubmit={handleSubmit(onSubmit)}>
      <br />
      <br />
      <br />
      <div className={classes.fieldLine}>
        <Controller
          name="email"
          control={control}
          render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
            <TextField
              fullWidth
              id="email"
              variant="outlined"
              label={t('email')}
              disabled={true}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              inputRef={ref}
              inputProps={{ maxLength: 255 }}
              InputLabelProps={{ required: true }}
              onChange={e => {
                setValue('email', sanitizeAlphaNumericAndSpecial(e.target.value));
              }}
              {...inputProps}
            />
          )}
        />
      </div>
      <div className={classes.fieldLine}>
        <Controller
          name="lastName"
          control={control}
          render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
            <TextField
              fullWidth
              id="lastName"
              variant="outlined"
              label={t('lastName')}
              disabled={readOnly}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              inputRef={ref}
              inputProps={{ maxLength: 100 }}
              InputLabelProps={{ required: true }}
              onChange={e => {
                setValue('lastName', sanitizeAlphaNumeric(e.target.value));
              }}
              {...inputProps}
            />
          )}
        />
      </div>
      <div className={classes.fieldLine}>
        <Controller
          name="firstName"
          control={control}
          render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
            <TextField
              fullWidth
              id="firstName"
              variant="outlined"
              label={t('firstName')}
              disabled={readOnly}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              inputRef={ref}
              inputProps={{ maxLength: 100 }}
              InputLabelProps={{ required: true }}
              onChange={e => {
                setValue('firstName', sanitizeAlphaNumeric(e.target.value));
              }}
              {...inputProps}
            />
          )}
        />
      </div>
    </form>
  );
};
